module.exports = __webpack_public_path__ + "static/img/img16.41a58b7.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/course/img16.jpg
// module id = bG+Q
// module chunks = 1